export const TECHNOLOGY_CARDS = [
  {
    code: "TX.01", name: "Integrated Matrix Engine", badge: "Patent Pending", href: "/technology",
    line: "Fuses labs, DNA, microbiome, wearables and biometrics into one connected optimization profile.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/n4nwcclm_An_illustrated_figure_silhouette_at_the_center_of_seven_inte.png",
    imageAlt: "Whole-person signals connected in one integrated intelligence profile",
  },
  {
    code: "TX.02", name: "Integrated Biological Age (IBA) 2.0", badge: "Patent Pending", href: "/biological-age",
    line: "A multi-modal biological age model weighing epigenetic, vascular and behavioral signals together.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/vfron9x6_An_illustrated_male_silhouette_integrated_with_DNA_helixes_a.png",
    imageAlt: "Biological, vascular and epigenetic age signals visualized together",
  },
  {
    code: "TX.03", name: "Multi-Tissue Biometric Engine", badge: "Patent Pending", href: "/technology",
    line: "Reads signals from skin, muscle, nerve and vascular layers simultaneously.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/ybzhssuw_cinematic_photorealistic_image_of_a_human_body_with_glowing_.png",
    imageAlt: "Full-body biometric data visualized across multiple tissue systems",
  },
  {
    code: "TX.04", name: "Wave-Harmonic Model — CardioSentry", badge: "Patent Pending", href: "/technology",
    line: "Analyzes EKG and EEG traces as connected wave patterns rather than isolated spikes.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/j89ocpxh_bilateral_sound_waves_and_alternating_light_pulses_around_a_.png",
    imageAlt: "Brain and bilateral wave signals visualized as connected patterns",
  },
  {
    code: "TX.05", name: "Multi-Tissue Photometric Engine", badge: "Patent Pending", href: "/technology",
    line: "Non-invasive, light-based reading of key body signals across multiple tissue depths.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/b2ledv8q_image_2.png",
    imageAlt: "Light-based human systems analysis across multiple tissue depths",
  },
  {
    code: "TX.06", name: "Body Composition & Metabolic Risk Engine™", badge: "Patent Pending", href: "/technology",
    line: "Reads body composition and metabolic risk together to support earlier, more informed evaluation.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/s95wyb9e_PnhPefA2sbp60gUQ%20%281%29.png",
    imageAlt: "Body composition and metabolic risk data mapped across the body",
  },
  {
    code: "TX.07", name: "Self-Regulation Console — BLS Engine", badge: "Patent Pending", href: "/technology",
    line: "A closed-loop bilateral-stimulation wellness system engineered with clinical rigor.",
    image: "https://customer-assets.emergentagent.com/job_integrated-matrix/artifacts/ytf7sar2_BLS%20Engine.png",
    imageAlt: "Bilateral stimulation self-regulation console",
  },
  {
    code: "TX.08", name: "Clinical Performance Index (CPI)", badge: "Scoring Framework", href: "/sample-analysis",
    line: "The 10-domain scoring framework that turns all of it into one longitudinal optimization profile.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/d5r7kph3_abstract_human_figure_with_six_glowing_modality_nodes_connec.png",
    imageAlt: "Connected physiological domains forming one longitudinal CPI profile",
  },
];